import traversingService from '../services/traversingService';

/**
 * Responsives Navigationsmenü
 */
class ResponsiveNavigation {
    /**
     * @param navigation {Node|Element} Das Navigationsmenü
     * @param triggers {NodeList|Array} Trigger zum Öffnen/Schließen des Menüs
     */
    constructor(navigation, triggers) {
        this.navigation = navigation;
        this.links = this.navigation.querySelectorAll('.js-responsive-navigation-link');
        this.triggers = triggers;
        this.html = document.documentElement;

        this.registerEvents();
    }

    registerEvents() {
        this.links.forEach((link) => {
            link.addEventListener('touchstart', ResponsiveNavigation.handleTouch);
        });

        this.triggers.forEach((trigger) => {
            trigger.addEventListener('click', this.toggleOverlay.bind(this));
        });
    }

    static handleTouch(event) {
        const target = event.currentTarget;
        const targetParent = traversingService.getParentByClass(target, 'js-responsive-navigation-parent');
        if (!targetParent) throw new Error('Parent not found');

        if (!targetParent.classList.contains('active')) {
            event.preventDefault();
            ResponsiveNavigation.toggleElement(targetParent);
        }
    }

    /**
     * @param element {Node|Element} Element das mit der "active" Klasse ge-toggeled werden soll.
     */
    static toggleElement(element = null) {
        if (element.classList.contains('active')) {
            element.classList.remove('active');
        } else {
            element.classList.add('active');
        }
    }

    toggleOverlay() {
        ResponsiveNavigation.toggleElement(this.navigation);

        if (this.html.classList.contains('no-scroll')) {
            this.html.classList.remove('no-scroll');
        } else {
            this.html.classList.add('no-scroll');
        }
    }
}

const responsiveNavigation = {
    init() {
        const navigation = document.querySelector('.js-responsive-navigation');
        const triggers = document.querySelectorAll('.js-responsive-navigation-trigger');

        if (!navigation || !triggers.length) {
            throw new Error('No elements found.');
        }

        this.navigation = new ResponsiveNavigation(navigation, triggers);
    },
};

export default responsiveNavigation;
